import React, { memo } from 'react';
import { Link } from 'react-router-dom';

export const PageHeading = memo(({
  logo = '',
}) => (
  <div className='recover-password-heading height-56 flex align-items-center justify-content-space-between p-l-6 p-r-6'>
    <div className='recover-password-logo'>
      <Link to='/' className='d-block'>
        <img id='recover-password-logo-element' className='height-30' src={logo} alt='logo' />
      </Link>
    </div>
  </div>
));

export default PageHeading;
